<template>
  <div class="comp-fh-ai-points-retry-button">
    <jw-button class="retry-btn" type="text" size="mini" :loading="loading" @click.stop="handleRetry">{{ aiPointsRetryButtonLabel }}</jw-button>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Message, Modal } from '@arco-design/web-vue';
import { aiService } from '@/api';
import { aiPointsRequestIdFieldKey, aiPointsRetryButtonLabel, aiPointsRetryConfirmContent, aiPointsRetryConfirmTitle, aiPointsRetrySuccessMessage, aiPointsRetryValidateFieldConfig } from '@/utils/const';
import { getFhAiPointsRequestId, validateFhAiPointsRetryData } from '@/utils/fh-ai-points.mjs';

const props = defineProps({
  row: {
    type: Object,
    default: () => ({})
  }
});

const emit = defineEmits(['success']);
const loading = ref(false);
const aiPointsRetrySuccessCodes = [0, 200];

const executeRetry = async (requestid) => {
  loading.value = true;

  try {
    const res = await aiService.retryAiWalletRecharge({ requestid });
    const bizCode = Number(res?.result?.code);
    const bizMsg = res?.result?.msg || res?.error?.msg || '';

    if (res?.error) {
      Message.error(bizMsg || '操作失败');
      return;
    }

    // 该接口外层 code=0，实际业务结果在 res.result.code / res.result.msg 中。
    // 目前后端成功码兼容 0 和 200，两种情况都需要进入刷新链路。
    if (!aiPointsRetrySuccessCodes.includes(bizCode)) {
      Message.error(bizMsg || '操作失败');
      return;
    }

    Message.success(bizMsg || aiPointsRetrySuccessMessage);
    // 通知上层列表在成功后刷新当前数据。
    emit('success');
  } catch (error) {
    Message.error(error?.message || '操作失败');
  } finally {
    loading.value = false;
  }
};

const handleRetry = () => {
  // requestid 来自列表行数据 input_xiQddQ，没有值时不发起重试请求。
  const requestid = getFhAiPointsRequestId(props.row, aiPointsRequestIdFieldKey);

  if (!requestid || loading.value) return;

  // 调重试接口前先校验关键业务字段，避免无效数据进入真实重试链路。
  const validationResult = validateFhAiPointsRetryData(props.row, aiPointsRetryValidateFieldConfig);

  if (!validationResult.valid) {
    Message.warning(validationResult.message);
    return;
  }

  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: aiPointsRetryConfirmTitle,
    content: aiPointsRetryConfirmContent,
    okText: '确定',
    cancelText: '取消',
    onOk: () => {
      executeRetry(requestid);
    }
  });
};
</script>

<style scoped lang="less">
@import './fh-ai-points-retry-button.less';
</style>
